import classNames from "classnames";
import React, { ReactElement } from "react";
import styles from "./BrokerConnectionMessage.module.scss";

require("lazysizes");

type BrokerDetail = {
  logoUrl: string;
  websiteUrl: string;
  name: string;
};

export const brokerDetailMapping: { [key: string]: BrokerDetail } = {
  "E*TRADE Financial": {
    logoUrl: "/images/ETradeLogo.png",
    websiteUrl: "https://www.etrade.com",
    name: "E*TRADE",
  },
  "E*TRADE Securities - Stock Plans": {
    logoUrl: "/images/ETradeLogo.png",
    websiteUrl: "https://www.etrade.com",
    name: "E*TRADE",
  },
  Tradier: {
    logoUrl: "/images/TradierLogo.png",
    websiteUrl: "https://www.tradier.com",
    name: "Tradier",
  },
  "TD Ameritrade": {
    logoUrl: "/images/td_ameritrade.svg",
    websiteUrl: "https://www.tdameritrade.com",
    name: "TD Ameritrade",
  },
};

interface Props {
  brokerName: string;
}

export default function BrokerConnectionMessage({
  brokerName,
}: Props): ReactElement {
  const selectedBroker = brokerDetailMapping[brokerName];

  if (!selectedBroker) {
    return <></>;
  }

  return (
    <div className={styles.brokerConnectionMessage}>
      <span className={styles.message}>Brokerage Connection Powered by</span>
      <a target="_blank" href={selectedBroker.websiteUrl}>
        <img
          className={classNames(styles.logo, "lazyload")}
          data-src={selectedBroker.logoUrl}
          alt={`${selectedBroker.name} Logo`}
        />
      </a>
    </div>
  );
}
